import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Constante } from '../models/constante';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Constantes';

@Injectable({
  providedIn: 'root'
})
export class ConstanteService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(constante: Constante)
  {
    return this._http.post({ url: baseUrl + '/Save', body: constante });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

  getListAgrupada(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/ListAgrupada' })
  }
}

